import PropTypes from 'prop-types';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { msToHMS } from '../../helpers';
import { NO_DATA } from '../../constants';

const ProjectWorkSessionEditRequests = ({
  worksessionList,
  handleWsCancelRequest,
}) => {
  const requestStatus = {
    pending: 'Pending',
    reviewed: 'Reviewed',
    approve: 'Approved',
    reject: 'Rejected',
    cancel: 'Cancelled',
  };
  return (
    <div className="table-responsive">
      {worksessionList.length > 0 ? (
        <table className="table table-sm table-hover card-table mt-1">
          <thead>
            <tr>
              <th>Team Member</th>
              <th>Original Worksession</th>
              <th>Updated Worksession</th>
              <th>Updated Remark</th>
              <th>Status</th>
              <th>Reason</th>
              <th>Requested By</th>
              <th>Updated By</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {worksessionList.map((request, index) => (
              <tr key={index}>
                <td>
                  {`${request.user.firstName} ${request.user.lastName || ''}`}
                </td>
                <td>
                  Duration: {msToHMS(request.oldWorkSessionSeconds * 1000)}
                  <br />
                  Check-in: {moment(request.oldCheckInDate).format('lll')}
                  <br />
                  Check-out: {moment(request.oldCheckOutDate).format('lll')}
                </td>
                <td>
                  Duration: {msToHMS(request.newWorkSessionSeconds * 1000)}
                  <br />
                  Check-in: {moment(request.newCheckInDate).format('lll')}
                  <br />
                  Check-out: {moment(request.newCheckOutDate).format('lll')}
                </td>
                <td>{request.updateRemark ? request.updateRemark : ' - '}</td>
                <td>{requestStatus[request.status]} </td>
                <td>{request.reason}</td>
                <td>{`${request.requestedBy.firstName} ${
                  request.requestedBy.lastName || ''
                }`}</td>
                <td>
                  {request.updatedBy
                    ? `${request.updatedBy.firstName} ${
                        request.updatedBy.lastName || ''
                      }`
                    : ' - '}
                </td>
                <td>
                  {request.status === 'pending' && (
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() =>
                        handleWsCancelRequest({
                          workSessionId: request.workSessionId,
                          requestId: request._id,
                          status: 'cancel',
                        })
                      }
                    >
                      Cancel Request
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="m-4">{NO_DATA.WS_CHANGE_REQUESTS}</p>
      )}
    </div>
  );
};

ProjectWorkSessionEditRequests.propTypes = {
  worksessionList: PropTypes.array,
  handleWsCancelRequest: PropTypes.func,
};

export default ProjectWorkSessionEditRequests;
